import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";

function LockAccount(){
    return (
        <div className="px-xxl-5">
            <div className="text-center mb-6">
                <div className="mb-3">
                    <h4 className="text-body-highlight mb-3">Account Suspended for Security</h4>
                    <p className="text-body-tertiary fs-8-1">We’ve detected unusual activity on your account and have locked it <strong>24H</strong> to prevent unauthorized access. Please reset your password or contact our support team immediately.</p>
                </div>
                <Link className="btn btn-primary w-100 mb-3" to="/home">
                    <FontAwesomeIcon className="me-2" icon={faChevronLeft} />
                    Go to home page  </Link>
                <Link to="#" className="fs-9 fw-bold text-decoration-underline" > Support center </Link>
            </div>
        </div>
    )
}
export default LockAccount;